import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ButtonReview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(42)};
  height: ${pxToRem(31)};
  border-radius: ${pxToRem(8)};
  padding: ${pxToRem(8)};
  margin: ${pxToRem(4)};
  cursor: pointer;
  background: ${({ value, theme: { colors } }) =>
    value <= 6 ? colors.sand_200 : value > 6 && value < 9 ? colors.warning_200 : colors.green_200};
  color: ${({ value, theme: { colors } }) =>
    value <= 6
      ? colors.danger_700
      : value > 6 && value < 9
        ? colors.warning_700
        : colors.green_800};
  border: ${({ value, rating }) => value === rating && '1px solid gray'};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: ${pxToRem(300)};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: ${pxToRem(16)};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    flex-direction: column;
    max-width: 80%;
  }
`;
export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  margin-top: ${pxToRem(16)};
`;
